







import { Component, Vue } from 'vue-property-decorator'

import Mir from '@/components/layouts/Mir.vue'

@Component({
  components: {
    Mir,
  },
})
class MirMobileView extends Vue {}

export default MirMobileView
